  import { defineComponent, type PropType } from "vue";
  import AccidentTravailCodeRisque from '@/extend/controls/accidentTravail/AccidentTravailCodeRisque';
  import AccidentTravailDateEffet from '@/extend/controls/accidentTravail/AccidentTravailDateEffet';
  import { Period } from '@/framework/base/helpers/DateFormat';
  import AccidentTravailSource from '@/extend/controls/accidentTravail/AccidentTravailSource';
  import AccidentTravailTauxPatronal from '@/extend/controls/accidentTravail/AccidentTravailTauxPatronal';
  import AccidentTravailType from '@/extend/controls/accidentTravail/AccidentTravailType';
  import AccidentTravail from '@/extend/classes/AccidentTravail';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeAccidentTravail } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      AccidentTravailCodeRisque,
      AccidentTravailDateEffet,
      AccidentTravailSource,
      AccidentTravailTauxPatronal,
      AccidentTravailType,
    },

    props: {
      accidentTravail: {
        type: Object as PropType<AccidentTravail>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        codeRisqueStatus: new FieldStatus(false, false, 0),
        strCodeRisque: '',
        dateEffetStatus: new FieldStatus(false, false, 0),
        strDateEffet: '',
        sourceStatus: new FieldStatus(false, false, 0),
        strSource: '',
        tauxPatronalStatus: new FieldStatus(false, false, 0),
        strTauxPatronal: '',
        typeStatus: new FieldStatus(false, false, 0),
        strType: '',
        refAccidentTravail: new AccidentTravail,
        cloneAccidentTravail: new AccidentTravail,
      accidentTravailSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.ACCIDENT_TRAVAIL,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editAccidentTravail.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editAccidentTravail: {
        get(): AccidentTravail {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.accidentTravail != undefined) {
              if (this.accidentTravail.id == 0) {
                Alerts.debug('CrudAccidentTravail : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneAccidentTravail.id != this.accidentTravail.id && !this.saving) {
                this.handleAccidentTravailChange();
              }
            }
          }
          return this.refAccidentTravail;
        },
        set(value: AccidentTravail) {
          this.refAccidentTravail = value;
        }
      },

      canCreate (): boolean {
        return this.refAccidentTravail.id > 0;
      },

      canDelete (): boolean {
        return this.refAccidentTravail.canDelete && this.refAccidentTravail.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },


      codeRisque: {
        get(): string {
          return this.editAccidentTravail.codeRisque;
        },
        set(value: string) {
          this.editAccidentTravail.codeRisque = value;
          this.fieldUpdated('CODE_RISQUE', value);
        }
      },


      dateEffet: {
        get(): Date {
          return this.editAccidentTravail.dateEffet;
        },
        set(value: Date) {
          this.editAccidentTravail.dateEffet = value;
          this.fieldUpdated('DATE_EFFET', value);
        }
      },

      periodDateEffet() : Period[] {
        return []
      },

      source: {
        get(): number {
          return this.editAccidentTravail.source;
        },
        set(value: number) {
          this.editAccidentTravail.source = value;
          this.fieldUpdated('SOURCE', value);
        }
      },


      tauxPatronal: {
        get(): string {
          return this.strTauxPatronal;
        },
        set(value: string) {
          const tauxPatronal = parseFloat(value);
          if (tauxPatronal.toString() == value) {
            this.editAccidentTravail.tauxPatronal = tauxPatronal;
            this.fieldUpdated('TAUX_PATRONAL', value);
          }
          this.strTauxPatronal = value;
        }
      },


      type: {
        get(): number {
          return this.editAccidentTravail.type;
        },
        set(value: number) {
          this.editAccidentTravail.type = value;
          this.fieldUpdated('TYPE', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.accidentTravail.canUpdate && (
        (this.isDisplayed('CODE_RISQUE') && !this.readOnly('CODE_RISQUE')) ||
        (this.isDisplayed('DATE_EFFET') && !this.readOnly('DATE_EFFET')) ||
        (this.isDisplayed('SOURCE') && !this.readOnly('SOURCE')) ||
        (this.isDisplayed('TAUX_PATRONAL') && !this.readOnly('TAUX_PATRONAL')) ||
        (this.isDisplayed('TYPE') && !this.readOnly('TYPE')));
        return !res;
      },

      fields (): string[] {
        return ['CODE_RISQUE', 'DATE_EFFET', 'SOURCE', 'TAUX_PATRONAL', 'TYPE'];
      },
    },

    methods: {
      handleAccidentTravailChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.accidentTravail);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.accidentTravail);
          }
        } else if (!this.inDialog) {
          if (this.cloneAccidentTravail.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.accidentTravail);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.codeRisqueStatus != undefined && this.codeRisqueStatus.updated) ||
          (this.dateEffetStatus != undefined && this.dateEffetStatus.updated) ||
          (this.sourceStatus != undefined && this.sourceStatus.updated) ||
          (this.tauxPatronalStatus != undefined && this.tauxPatronalStatus.updated) ||
          (this.typeStatus != undefined && this.typeStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.accidentTravail);
        }
      },

      setError (): void {
        const error = this.codeRisqueStatus.error ||
        this.dateEffetStatus.error ||
        this.sourceStatus.error ||
        this.tauxPatronalStatus.error ||
        this.typeStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.accidentTravail);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refAccidentTravail.id < 0) {
          storeAccidentTravail.mAccidentTravailDeleted(this.refAccidentTravail.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refAccidentTravail.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveAccidentTravail()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.accidentTravailSaving = false;
          this.createRef(this.refAccidentTravail);
          this.$emit('updated', this.refAccidentTravail);
          if (this.accidentTravail.id > 0) {
            this.$emit('saved', this.refAccidentTravail);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refAccidentTravail.failed) {
          this.saveLoading = false;
            this.accidentTravailSaving = false;
            this.refAccidentTravail.failed = false;
          }
        }
      },

      saveAccidentTravail (): boolean {
        if (!this.refAccidentTravail.compareAccidentTravail(this.cloneAccidentTravail)) {
          if (!this.accidentTravailSaving) {
            this.accidentTravailSaving = true;
          if (this.refAccidentTravail.id > 0) {
            storeAccidentTravail.updateAccidentTravail(this.refAccidentTravail)
              .then((data: AccidentTravail) => {
                if (!data.failed) {
                  this.refAccidentTravail = storeAccidentTravail.getAccidentTravail(data.id);
                  this.cloneAccidentTravail = data.cloneAccidentTravail();
                } else {
                  this.refAccidentTravail.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.accidentTravailSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refAccidentTravail.id <= 0) {
              storeAccidentTravail.createAccidentTravail(this.refAccidentTravail)
                .then((data: AccidentTravail) => {
                  if (!data.failed) {
                    this.refAccidentTravail = storeAccidentTravail.getAccidentTravail(data.id);
                    this.cloneAccidentTravail = data.cloneAccidentTravail();
                  } else {
                this.refAccidentTravail.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.accidentTravailSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refAccidentTravail.id <= 0) {
          storeAccidentTravail.mAccidentTravailDeleted(this.refAccidentTravail.id);
        } else {
          storeAccidentTravail.deleteAccidentTravail(this.refAccidentTravail);
        }
      },

      statusCodeRisque (value: FieldStatus): void {
        this.codeRisqueStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusDateEffet (value: FieldStatus): void {
        this.dateEffetStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusSource (value: FieldStatus): void {
        this.sourceStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusTauxPatronal (value: FieldStatus): void {
        this.tauxPatronalStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusType (value: FieldStatus): void {
        this.typeStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteAccidentTravail(): void {
        this.$emit('deleteAccidentTravail',  this.accidentTravail);
      },

    addAccidentTravail(): void {
      this.$emit('addAccidentTravail',  this.accidentTravail);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneAccidentTravail != undefined) {
          this.restoring = true;
          this.refAccidentTravail.codeRisque = this.cloneAccidentTravail.codeRisque;
          this.refAccidentTravail.dateEffet = this.cloneAccidentTravail.dateEffet;
          this.refAccidentTravail.source = this.cloneAccidentTravail.source;
          this.refAccidentTravail.tauxPatronal = this.cloneAccidentTravail.tauxPatronal;
          this.refAccidentTravail.type = this.cloneAccidentTravail.type;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: AccidentTravail): void {
        this.clearRef();
        this.editAccidentTravail = value;
        this.cloneAccidentTravail = value.cloneAccidentTravail();
        this.codeRisqueStatus.clear(value.id);
        this.dateEffetStatus.clear(value.id);
        this.sourceStatus.clear(value.id);
        this.tauxPatronalStatus.clear(value.id);
        this.typeStatus.clear(value.id);
        this.status.clear();
        this.strTauxPatronal = this.editAccidentTravail.tauxPatronal.toString();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('CODE_RISQUE') && this.$refs.CODE_RISQUE) this.$refs.CODE_RISQUE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_EFFET') && this.$refs.DATE_EFFET) this.$refs.DATE_EFFET.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('SOURCE') && this.$refs.SOURCE) this.$refs.SOURCE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('TAUX_PATRONAL') && this.$refs.TAUX_PATRONAL) this.$refs.TAUX_PATRONAL.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('TYPE') && this.$refs.TYPE) this.$refs.TYPE.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CODE_RISQUE') && this.isDisplayed('CODE_RISQUE') && this.$refs.CODE_RISQUE && this.$refs.CODE_RISQUE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DATE_EFFET') && this.isDisplayed('DATE_EFFET') && this.$refs.DATE_EFFET && this.$refs.DATE_EFFET.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'SOURCE') && this.isDisplayed('SOURCE') && this.$refs.SOURCE && this.$refs.SOURCE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'TAUX_PATRONAL') && this.isDisplayed('TAUX_PATRONAL') && this.$refs.TAUX_PATRONAL && this.$refs.TAUX_PATRONAL.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'TYPE') && this.isDisplayed('TYPE') && this.$refs.TYPE && this.$refs.TYPE.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('CODE_RISQUE') && this.$refs.CODE_RISQUE) this.$refs.CODE_RISQUE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_EFFET') && this.$refs.DATE_EFFET) this.$refs.DATE_EFFET.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('SOURCE') && this.$refs.SOURCE) this.$refs.SOURCE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('TAUX_PATRONAL') && this.$refs.TAUX_PATRONAL) this.$refs.TAUX_PATRONAL.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('TYPE') && this.$refs.TYPE) this.$refs.TYPE.save();
      },

      getValue (field: string): string {
         if (field == 'CODE_RISQUE') return this.codeRisque.toString();
        else  if (field == 'DATE_EFFET') return this.dateEffet.toString();
        else  if (field == 'SOURCE') return this.source.toString();
        else  if (field == 'TAUX_PATRONAL') return this.tauxPatronal.toString();
        else  if (field == 'TYPE') return this.type.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
